import type { ControllerFieldState } from 'react-hook-form';
import { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

import {
  type IRadioButton,
  RadioButton,
} from '../../../../Toolkit/Inputs/RadioButton';
type FinanceRadioButtonProps = Omit<IRadioButton, 'hasError'> &
  ControllerFieldState & { isOptional?: boolean };

export const FinanceRadioButton = forwardRef<
  HTMLInputElement,
  FinanceRadioButtonProps
>((props, ref) => {
  const { invalid, value, onFocus, ...rest } = props;
  const { clearErrors } = useFormContext();
  return (
    <RadioButton
      {...rest}
      hasError={invalid}
      ref={ref}
      value={value}
      onFocus={() => {
        clearErrors(props.name);
        onFocus?.();
      }}
    />
  );
});

FinanceRadioButton.displayName = 'FinanceRadioButton';
